
const Q = require('q');
const _ = require('lodash');

const $ = require('jquery');

const ko = require('knockout');

const SinglePromiseQueue = require('single-promise-queue');
const animations = require('animations');


function visibleBindingFactory (options) {
	options = _.extend({
		show: function (el) {
			return Q($(el).show());
		},
		hide: function (el) {
			return Q($(el).hide());
		},
	}, options);

	return {
		init: function (element, valueAccessor) {
			const animations = new SinglePromiseQueue();

			let initRun = true;
			ko.computed(function () {
				const shouldBeVisible = Boolean(ko.unwrap(valueAccessor()));

				if (initRun) {
					initRun = false;
					$(element).toggle(shouldBeVisible);
					return;
				}

				if (shouldBeVisible) {
					animations.push(function () {
						return Q(options.show(element));
					});
				} else {
					animations.push(function () {
						return Q(options.hide(element));
					});
				}
			}, null, { disposeWhenNodeIsRemoved: element });
		},
	};
}

ko.bindingHandlers.visibleAnimated = visibleBindingFactory({
	show: animations.slideDown,
	hide: animations.slideUp,
});

ko.bindingHandlers.visibleAnimatedFade = visibleBindingFactory({
	show: animations.fadeIn,
	hide: animations.fadeOut,
});
